"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
function promisify(fn) {
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return new Promise(function (resolve, reject) {
      var nodeCallback = function nodeCallback(err, result) {
        if (err) reject(err);else resolve(result);
      };
      fn.apply(null, __spreadArrays(args, [nodeCallback]));
    });
  };
}
exports.promisify = promisify;